const fr: Record<string, string> = {
  'features.meals.empty': 'Aucun repas planifié pour le moment.',
  'features.meals.exportPdf': 'Exporter en PDF',
  'features.meals.newMeal': 'Nouveau repas',
  'features.meals.title': 'Titre',
  'features.meals.titlePlaceholder': 'Optionnel',
  'features.meals.untitled': 'Repas sans titre',
  'features.meals.date': 'Date',
  'features.meals.headcount': 'Nombre de personnes',
  'features.meals.headcountValue': '{{count}} personnes',
  'features.meals.headcountShort': '{{count}}p.',
  'features.meals.mealTime': 'Repas',
  'features.meals.slot.morning': 'Matin',
  'features.meals.slot.midday': 'Midi',
  'features.meals.slot.evening': 'Soir',
  'features.meals.cancel': 'Annuler',
  'features.meals.create': 'Créer',
  'features.meals.delete': 'Supprimer le repas',
  'features.meals.archive': 'Archiver',
  'features.meals.readMode': 'Mode lecture',
  'features.meals.close': 'Fermer',
  'features.meals.description': 'Description',
  'features.meals.participants': 'Participants',
  'features.meals.selectParticipants': 'Choisir les participants',
  'features.meals.selectRecipes': 'Choisir les recettes',
  'features.meals.recipes': 'Recettes',
  'features.meals.noRecipes': "Aucune recette dans ce projet pour l'instant.",
};

export default fr;
